export const SPOONACULAR_RANDOM_RECIPE_API = process.env.REACT_APP_SPOONACULAR_RANDOM_RECIPE_API;

export const SPOONACULAR_RECIPE_API = process.env.REACT_APP_SPOONACULAR_RECIPE_API;

export const SPOONACULAR_API_KEY = process.env.REACT_APP_SPOONACULAR_API_KEY;

export const SPOONACULAR_RECIPE_INFO_API = process.env.REACT_APP_SPOONACULAR_RECIPE_INFO_API;

export const THEMEALDB_LOOKUP_API = process.env.REACT_APP_THEMEALDB_LOOKUP_API;
export const THEMEALDB_SEARCH_API = process.env.REACT_APP_THEMEALDB_SEARCH_API;
export const THEMEALDB_FILTER_BY_CATEGORY_API = process.env.REACT_APP_THEMEALDB_FILTER_BY_CATEGORY_API;
export const THEMEALDB_CATEGORIES_API = process.env.REACT_APP_THEMEALDB_CATEGORIES_API;


export const THEMEALDB_AREAS_API = process.env.REACT_APP_THEMEALDB_AREAS_API;
export const THEMEALDB_FILTER_BY_AREA_API = process.env.REACT_APP_THEMEALDB_FILTER_BY_AREA_API;

